module.exports = __webpack_public_path__ + "static/img/95044A_2_3_R_20181128_LC.bd2ea8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95044A_2_3_R_20181128_LC.png
// module id = uIO2
// module chunks = 0